// Ubicación en el repo: src/lib/suppliers.js
// Proveedores (migración 0046, Fase A del módulo de Inventario/
// Contabilidad — ver plan-inventario-y-contabilidad.md, 24-ago-2026).
// Entidad nueva, sin equivalente previo — hoy solo se usa para asociar un
// proveedor "habitual" a un producto del catálogo (útil para reclamos de
// garantía); las Fases D en adelante la usan para compras/gastos.
import { supabase } from './supabaseClient';

export async function listActiveSuppliers() {
  const { data, error } = await supabase
    .from('suppliers')
    .select('id, name, rut, contact_name, phone, email')
    .is('deleted_at', null)
    .order('name', { ascending: true });
  if (error) throw error;
  return data ?? [];
}

export async function listAllSuppliersForAdmin() {
  const { data, error } = await supabase
    .from('suppliers')
    .select('id, name, rut, contact_name, phone, email, deleted_at')
    .order('name', { ascending: true });
  if (error) throw error;
  return data ?? [];
}

export async function createSupplier({ name, rut, contactName, phone, email }) {
  const { data, error } = await supabase
    .from('suppliers')
    .insert({
      name: name.trim(),
      rut: rut?.trim() || null,
      contact_name: contactName?.trim() || null,
      phone: phone?.trim() || null,
      email: email?.trim() || null,
    })
    .select('id')
    .single();
  if (error) throw error;
  return data.id;
}

export async function updateSupplier(id, { name, rut, contactName, phone, email }) {
  const { error } = await supabase
    .from('suppliers')
    .update({
      name: name.trim(),
      rut: rut?.trim() || null,
      contact_name: contactName?.trim() || null,
      phone: phone?.trim() || null,
      email: email?.trim() || null,
    })
    .eq('id', id);
  if (error) throw error;
}

export async function softDeleteSupplier(id, actorId) {
  const { error } = await supabase
    .from('suppliers')
    .update({ deleted_at: new Date().toISOString(), deleted_by: actorId })
    .eq('id', id);
  if (error) throw error;
}

export async function restoreSupplier(id) {
  const { error } = await supabase.from('suppliers').update({ deleted_at: null, deleted_by: null }).eq('id', id);
  if (error) throw error;
}
